// Column widths of the modal, in px. The chat column is the whole surface
// until a script preview opens beside it; the Modal `size` is the sum of the
// open columns, so the surface animates between the two totals while the
// chat column keeps its width.
export const CHAT_WIDTH = 680;
export const PREVIEW_WIDTH = 528;
